import React from "react";
import Box, { BoxProps } from "@mui/material/Box";
import { EmtTypography } from "./EmtTypography";
import { styled } from "@mui/material/styles";
import Alert, { AlertColor, AlertProps } from "@mui/material/Alert";
import { EmtTheme } from "../types";

export type EmtAlertProps = AlertProps & {
  title: React.ReactNode | string;
  caption?: React.ReactNode | string;
  /**
   * Define visibility of component
   * animation is trigger when the value change
   * @default false
   */
  isOpen?: boolean;
  nonce?: string;
};

type LeftBoxProps = BoxProps & {
  color: AlertColor;
  theme?: EmtTheme & any;
};

const LeftBox = styled(Box)(({ theme, color }: LeftBoxProps) => ({
  width: "8px",
  height: "36px",
  position: "absolute",
  top: "50%",
  left: "-4px",
  background:
    color === "info"
      ? theme?.palette.greyGradient[250]
      : theme?.palette[color].light,
  transform: "translateY(-50%)",
  borderRadius: "4px",
}));

const CaptionTypography = styled(EmtTypography)(
  ({ theme }: { theme?: EmtTheme }) => ({
    color: theme?.palette.greyGradient.light,
  })
);

export function EmtAlert(props: EmtAlertProps) {
  const { title, caption, severity = "info", isOpen = false, ...rest } = props;

  return (
    <Alert severity={severity} {...rest}>
      <LeftBox color={severity} />
      <EmtTypography
        variant="body1"
        fontWeight="bold"
        sx={{ fontSize: "14px" }}
      >
        {title}
      </EmtTypography>
      {caption && (
        <CaptionTypography variant="caption">
          <>{caption}</>
        </CaptionTypography>
      )}
    </Alert>
  );
}
